import i18next from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { getLanguages } from "../models/settings";

export const configureI18n = () => {
  const { languages, default: defaultLanguage } = getLanguages();
  i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      load: "currentOnly",
      fallbackLng: "en",
      lng: defaultLanguage,
      supportedLngs: languages,
      defaultNS: "common",
      debug: false,
      ns: ["common"],
      interpolation: { escapeValue: false },
      backend: {
        loadPath: (lng: string[], ns: string[]) => {
          const [fileName] = ns;
          return `/i18n/${lng}/${fileName}.json?v=${
            import.meta.env.VITE_BUILD
          }`;
        },
        crossDomain: true,
      },
      keySeparator: "",
      react: {
        useSuspense: false,
      },
    });
};
